import React from 'react'

//Node Modules
import { DomElement } from 'html-react-parser'

//Components
import Comment from 'components/xis/Comment'

export default ({ data }:DomElement, params:any, options:any) => {
  const text = data as string
  return <Comment text={text} />
}